import { useCallback } from 'react'
import { useAppDispatch } from '../../../../../../../../../../app/hooks'
import { AttachmentData, AttachmentStatus } from '../../../../../../../../../../@types/types'
import { changeImageOrder } from '../../../../../../../../../../redux/thunks/multimedia/multimedia'

export const usePersistedPictureReorder = (attachments: AttachmentData[]) => {
  const dispatch = useAppDispatch()

  return useCallback(
    (activeId: string, overId: string) => {
      const activeAttachment = attachments.find((attachment) => attachment.attachment?.id === activeId)
      const overAttachment = attachments.find((attachment) => attachment.attachment?.id === overId)

      if (
        activeAttachment?.state === AttachmentStatus.PERSISTED &&
        overAttachment?.state === AttachmentStatus.PERSISTED
      ) {
        dispatch(changeImageOrder(activeId, overId))
      }
    },
    [attachments, dispatch]
  )
}
